import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";

interface RegistNewGoodsProposalResponse {
  ProposalId: string;
}
/**
 * 一時保存時に新規商品提案情報を保存するサービス
 *
 * @export RegistNewGoodsProposalService
 * @class RegistNewGoodsProposalService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistNewGoodsProposalService extends PlessJsonResponderSub<RegistNewGoodsProposalResponse> {
  private model: KYMW6901ProposalTabModel;
  private proposalUserId: string;
  private proposalStatus: string;
  private successFunc: (proposalId: string) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistNewGoodsProposalService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        registNewGoodsProposal: {
          parameter: {
            ClassCode: this.model.newGoodsProposal.classCode,
            ProposalBuyerId: this.model.newGoodsProposal.buyerUserId,
            ProposalGoodsName: this.model.newGoodsProposal.goodsName,
            ProposalName: this.model.newGoodsProposal.standardName,
            JanCode: this.model.newGoodsProposal.janCode,
            ProposalSalesPoint: this.model.newGoodsProposal.salesPoint,
            SuggestedPriceSellingNormal: this.model.newGoodsProposal.standardSellingPrice,
            SuggestedPriceSellingSpecial1: this.model.newGoodsProposal.special1SellingPrice,
            SuggestedPriceSellingSpecial2: this.model.newGoodsProposal.special2SellingPrice,
            SuggestedPricePurchaseNormal: this.model.newGoodsProposal.standardCostPrice,
            SuggestedPricePurchaseSpecial1: this.model.newGoodsProposal.special1CostPrice,
            SuggestedPricePurchaseSpecial2: this.model.newGoodsProposal.special2CostPrice,
            ConsumeByDate: this.model.newGoodsProposal.expirationDate,
            ConsumeTerm: this.model.newGoodsProposal.bestBeforeDate,
            ExpansionStartSuggestedOrderCode: this.model.newGoodsProposal.preferredOrderCode,
            SuggestedExpansionDiv: this.model.newGoodsProposal.preferredExpansionDiv,
            SuggestedExpansionDivOther: this.model.newGoodsProposal.preferredExpansionOther,
            MonthAge: this.model.newGoodsProposal.monthAge,
            ProductionFactory: this.model.newGoodsProposal.productionFactory,
            ManufacturingFactory: this.model.newGoodsProposal.manufacturingFactory,
            DeliGoodsStandardCheckedFlg: this.model.newGoodsProposal.deliGoodsChecked ? '1' : '0',
            GoodsStandardCheckedOrderFlg: this.model.newGoodsProposal.goodsCheckRequest ? '1' : '0',
            TemperatureDiv: this.model.newGoodsProposal.temperatureDiv,
            OrderClientName: this.model.newGoodsProposal.orderClientName,
            MakerName: this.model.newGoodsProposal.markerName,
            Allergen: this.model.newGoodsProposal.allergen,
            AdditionObject: this.model.newGoodsProposal.additives,
            CookingMethod: this.model.newGoodsProposal.cookingMethod,
            MdbRegistFlg: this.model.newGoodsProposal.mobRegistered ? '1' : '0',
            ShootingOrder: this.model.newGoodsProposal.shootingInstruction,
            ImagePhoto: this.model.newGoodsProposal.imageFileName,
            ShootingImage: this.model.newGoodsProposal.shootingImage,
            Note: this.model.newGoodsProposal.note,
            PredictedPoints: this.model.newGoodsProposal.predictedPoints,
            ProposalStatus: this.proposalStatus,
            ProposalUserId: this.proposalUserId,
          }
        },
        CoopCodeList: {
          combination: this.model.expandableCoopToCoopCodeList().map(coopCode => ({
            parameter: {
              CoopCode: coopCode
            }
          }))
        }

      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistNewGoodsProposalService
   */
  execute(
    model: KYMW6901ProposalTabModel,
    proposalUserId: string,
    proposalStatus: string,
    successFunc?: (proposalId: string) => void
  ) {
    this.model = model;
    this.proposalUserId = proposalUserId;
    this.proposalStatus = proposalStatus;
    this.successFunc = successFunc;
    this.send('registNewGoodsProposal', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * 
   * @memberof RegistNewGoodsProposalService
   */
  success(data: RegistNewGoodsProposalResponse): void {
    const proposalId = data.ProposalId;
    if (this.successFunc) {
      this.successFunc(proposalId);
    }
  }
}

